$(function() {
  $(window).on('resize', function(event) {
    $('.teaser-box .video-header').each(function(i, e) {
      $(this).css('height', ($(this).width() / 3 * 2));
    });
  }).trigger('resize');
});